<template>
<div>
    <h2>{{ $t("editRepeatsView.setEstimatedLaps") }}</h2>
    <input id="estimatedRepeats" type="number" v-model="eventParticipant.estimatedRepeats" :disabled="eventParticipant.repeatsLocked">
    
    <h2>{{ $t("editRepeatsView.repeats") }}</h2>
    <input id="repeats" type="number" v-model="eventParticipant.repeats" :disabled="eventParticipant.repeatsLocked">

    <div>
        <button :disabled="!isValidatedForSave" class="button button-green" @click="save()">
            {{ $t("editRepeatsView.save") }}
        </button>
    </div>
</div>
</template>

<script lang="ts">
import { store, EventParticipant } from "store";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        return {
            store: store,
            eventParticipant: store.selectedEvent.eventParticipant
        };
    },
    computed: {
        isValidatedForSave() {
            let { estimatedRepeats, repeats } = this.eventParticipant;
            return (estimatedRepeats == null || estimatedRepeats >= 0) && (repeats == null || repeats >= 0);
        }
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("editRepeatsView.title") as string;
            store.page.showTopNav = true;
        },
        async save() {
            try {
                await axios.put<EventParticipant>(`eventparticipants/${this.eventParticipant.eventParticipantId}`, this.eventParticipant);
                this.$router.push('/');
            } catch(e) {
                // TODO: Handle error.
            }
        }
    }
})

</script>